/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';
import { Accordion, Spinner } from 'react-bootstrap';
import {
  ListItemsComp,
  TextComp,
  HtmlComp,
  MultiColList,
  TableComp,
  CheckLists,
} from './components';

import { TimelineMercury } from '@vlinder-web/timeline-mercury-widget-react';
import { CheckedItems } from '../CheckedItems';

import * as S from './styles';
import './styles.css';

interface listItems {
  type:
    | 'text'
    | 'markup'
    | 'list'
    | 'multi-col-list'
    | 'timeline'
    | 'table'
    | 'check-list';
  title: string;
  data: any;
  styleProps: any;
}

export interface IAccordionProps {
  accordionItems: listItems[];
  timelineCardClick?(id: string): void;
  [key: any]: any;
}

export const AccordionComp = (props: IAccordionProps) => {
  const { accordionItems, timelineCardClick, ...rest } = props;

  const _getAccordionBody = (item) => {
    switch (item?.type) {
      case 'list':
        return <ListItemsComp listItems={item?.data} />;
      case 'timeline':
        return (
          <TimelineMercury items={item?.data} onItemClick={timelineCardClick} />
        );
      case 'text':
        return <TextComp {...item} />;
      case 'markup':
        return <HtmlComp {...item} />;
      case 'multi-col-list':
        return <MultiColList {...item} />;
      case 'table':
        return <TableComp {...item} rowValues={item?.data} />;
      case 'check-list':
        return <CheckLists {...item} />;
      default:
        return null;
    }
  };

  const _renderAccordion = (item: listItems) => {
    return (
      <Accordion
        defaultActiveKey={item?.title}
        style={S.AccordionStyle}
        className="mt-2"
      >
        <Accordion.Item eventKey={item?.title}>
          <Accordion.Header style={S.HeaderStyle}>
            <h5 className="fw-bold p-2">{item?.title}</h5>
          </Accordion.Header>
          <hr />
          <Accordion.Body>{_getAccordionBody(item)}</Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };
  return (
    <>
      {Array.isArray(accordionItems) &&
        accordionItems?.map((item: listItems) => {
          return <>{_renderAccordion(item)}</>;
        })}
    </>
  );
};

AccordionComp.defaultProps = {};
